<template>
  <div :class="classes()">
    <Headline noMargin size="m" isViewHeadline>Mein Profil</Headline>

    <IntroBanner
      :headline="$t('profile.introBanner.headline')"
      :copy="$t('profile.introBanner.copy')"
      :bottomSpace="40"
      :localStorage="LS_PROFILE_INFO_BANNER"
    />

    <Widget headline="Persönliche Daten">
      <PersonalDataForm :el="el" />
    </Widget>

    <Widget headline="Zugangsdaten">
      <AccessDataForm :el="el" />
    </Widget>

    <Widget headline="Meine Daten">
      <AccountData :el="el" @onTrackingClick="trackClick" />
    </Widget>

    <Widget headline="Rechtliches">
      <Legal :el="el" @onTrackingClick="trackClick" />
    </Widget>
  </div>
</template>

<script>
import Widget from '@/objects/Widget';
import Headline from '@/objects/Headline';
import PersonalDataForm from '@/components/Forms/PersonalDataForm/PersonalDataForm';
import AccountData from '@/views/Profile/subcomponents/AccountData';
import AccessDataForm from '@/components/Forms/AccessDataForm/AccessDataForm';
import IntroBanner from '@/components/IntroBanner';
import Legal from '@/views/Profile/subcomponents/Legal.vue';

import { LS_PROFILE_INFO_BANNER } from '@/constants/storage';
import { createTrackingData } from '@/helpers/tracking/utils/helpers';

export default {
  name: 'Profile',
  components: {
    Legal,
    IntroBanner,
    AccountData,
    AccessDataForm,
    PersonalDataForm,
    Headline,
    Widget,
  },
  props: {},
  data() {
    return {
      LS_PROFILE_INFO_BANNER,
      el: 'v-profile',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
  methods: {
    trackClick(labelText, element = 'link') {
      const product = 'Account';
      const label = product + labelText;

      createTrackingData(product, label, element);
    },
  },
};
</script>
